import { useRoutes } from 'react-router-dom'
import { DocsRoute, PrivateRoute, PublicRoute } from 'routes'

export const Routes = () => useRoutes([PublicRoute, PrivateRoute, DocsRoute])
